<template>
  <CustomControl position="TOP_RIGHT">
    <button id="accessibleRoutes" :class="showAccessibleRoutes ? 'pressed' : ''"
      aria-label="Show accessible routes" :aria-pressed="showAccessibleRoutes"
      @click="toggleAccessibleRoutes()">
      <font-awesome-icon icon="check" v-if="showAccessibleRoutes" />
      Accessible Routes
    </button>
  </CustomControl>

  <div v-if="showAccessibleRoutes">
    <Polyline
      v-for="line in latLngLineList"
      :options="{
        path: line,
        strokeColor: '#011451',
        strokeWeight: 3,
      }"/>
  </div>
</template>

<script setup>
import {Polyline, CustomControl} from "vue3-google-map";
import {ref, onMounted} from "vue";
import axios from 'axios'
import { useRoute, useRouter } from 'vue-router'

const route = useRoute()
const router = useRouter()

const latLngLineList = ref([]);
const accessibleRouteNodes = ref(null);
const showAccessibleRoutes = ref(false)

onMounted(async() => {
  accessibleRouteNodes.value = await fetchAccessibleRouteNodes();
  latLngLineList.value = coordinateLineListToLatLngLineList(accessibleRouteNodes.value);
  //Check URL to see if routes should be shown by default
  checkUrlQuery()
})

function toggleAccessibleRoutes() {
  showAccessibleRoutes.value = !showAccessibleRoutes.value
  router.replace({
        query: {
          ...route.query,
          showAccessibleRoutes: showAccessibleRoutes.value
        }
      })
}

// convert list from format
// [[[x, y], [x,y]],[[x, y], [x,y]]]
// to
// [[{lat: x, lng: y},{lat: x, lng: y}], [{lat: x, lng: y}, {lat: x, lng: y}]]
function coordinateLineListToLatLngLineList(coordinateLineList) {
  return coordinateLineList.map(line =>
    ([{lat: line[0][1], lng: line[0][0]}, {lat: line[1][1], lng: line[1][0]}])
  );
}

async function fetchAccessibleRouteNodes() {
  let request = '/map/features?showBuildings=false&showAccessibleRoutes=true&showCycleRoutes=false&showAccessibleParking=false&showAccessibleToilets=false&showBikeRacks=false&showToilets=false&showFoodOutlets=false&showAttractions=false&showAtms=false&showShowers=false&showPrayerAndReflection=false&showBabyChanging=false&showDefibrillators=false&showPeriodProducts=false&showRetailOutlets=false&showWaterFountains=false&preview=false'

  let featuresResponse = await axios.get(request, {withCredentials: false});

  return featuresResponse.data.features[0].geometry.coordinates;
}

function checkUrlQuery() {
  if(route.query.showAccessibleRoutes === "true") {
    showAccessibleRoutes.value = true
  } 
}

</script>

<style scoped>
#accessibleRoutes {
  background-color :#fff;
  border:none;
  box-shadow: rgba(0, 0, 0, 0.3) 0px 2px 6px;
  color: #191919;
  cursor: pointer;
  font-family: Roboto, Arial, sans-serif;
  font-size: 14px;
  margin: 8px 10px 22px;
  padding: 10px 5px;
  text-align: center;
}

#accessibleRoutes.pressed{
  background-color: var(--uog-dark-blue);
  color: #fff;
}
</style>
